import React from 'react';
import { Link } from 'react-router-dom';
import notfound from '../img/404.svg'

function NotFound() {
    return (
        <div className='bg-slate-100 h-screen flex flex-col gap-y-20 items-center justify-center'>
            <img src={notfound} alt="svg" className='w-1/3' />
            <Link to={'/'}>
                <button className='group bg-[#F50057] flex gap-x-2 items-center py-2 px-5 rounded-lg text-white'>
                    <svg className="w-5 h-5 transition-all duration-150 group-hover:-translate-x-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>
                    <p className='font-semibold'>Back to homepage</p>
                </button>
            </Link>
        </div>
    );
}

export default NotFound;